import imagesReducer from './reducer';
import * as imagesTypes from './types';
import * as imagesActions from './actions';

export { imagesTypes, imagesActions };

export default imagesReducer;



// WEBPACK FOOTER //
// ./src/module/redux/modules/images/index.js